/**
 * 고객센터 연락처 — 로그인 화면 하단에 노출한다.
 * 카카오톡은 루다링크 앱과 같은 채널(채팅 링크)을 쓴다. 채널 ID는 env.* 의 VITE_KAKAO_CHANNEL_ID.
 */
const kakaoChannelId = import.meta.env.VITE_KAKAO_CHANNEL_ID?.trim();

export const SUPPORT = {
  hours: '평일 10:00-17:00',
  phone: '1600-3884',
  email: 'admin@rudalink.com',
  /** 채널 ID가 없으면 null — 링크 없이 숨긴다 */
  kakaoChatUrl: kakaoChannelId
    ? `https://pf.kakao.com/${kakaoChannelId}/chat`
    : null,
  homepageUrl: 'https://rudalink.com',
} as const;
